var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrioritySupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 59,
    rx: 12,
    fill: "#FDE2E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 38.5V36.5C21 35.4391 21.4214 34.4217 22.1716 33.6716C22.9217 32.9214 23.9391 32.5 25 32.5H29C30.0609 32.5 31.0783 32.9214 31.8284 33.6716C32.5786 34.4217 33 35.4391 33 36.5V38.5M34 20.63C34.8604 20.8503 35.623 21.3507 36.1676 22.0523C36.7122 22.7539 37.0078 23.6168 37.0078 24.505C37.0078 25.3932 36.7122 26.2561 36.1676 26.9577C35.623 27.6593 34.8604 28.1597 34 28.38M39 38.5V36.5C38.9949 35.6172 38.6979 34.7608 38.1553 34.0644C37.6126 33.368 36.8548 32.8707 36 32.65M23 24.5C23 25.5609 23.4214 26.5783 24.1716 27.3284C24.9217 28.0786 25.9391 28.5 27 28.5C28.0609 28.5 29.0783 28.0786 29.8284 27.3284C30.5786 26.5783 31 25.5609 31 24.5C31 23.4391 30.5786 22.4217 29.8284 21.6716C29.0783 20.9214 28.0609 20.5 27 20.5C25.9391 20.5 24.9217 20.9214 24.1716 21.6716C23.4214 22.4217 23 23.4391 23 24.5Z",
    stroke: "url(#paint0_linear_830_10673)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_830_10673",
    x1: 21,
    y1: 29.5,
    x2: 39,
    y2: 29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrioritySupport);
export default __webpack_public_path__ + "static/media/Priority Support.7dc60d0300cdb8246348061d916a3bbb.svg";
export { ForwardRef as ReactComponent };